import React, { useContext } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CurrentUserContext } from '../../context/CurrentUserContext';

const Login = () => {
  let navigate = useNavigate();
  const { setCurrentUser } = useContext(CurrentUserContext);
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = async (e:React.SyntheticEvent) => {
    e.preventDefault();
    const response = await fetch("https://api-j06q.onrender.com/api/user/login", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password
      })
    })

    const data = await response.json();
    console.log(data);
    if (!response.ok) {
      setError(data.error)
    }
    if (response.ok) {
      setError(null)
      localStorage.setItem('token', JSON.stringify(data.user._id))
      localStorage.setItem("userName", data.user.name);
      if (data.user.role.includes("Instructor")) {
        localStorage.setItem("userRole", "Instructor")
        navigate('/instructor')
      } else {
        localStorage.setItem("userRole", data.user.role)
        navigate('/')
      }
      localStorage.setItem("user_token",data.token)
      setCurrentUser(data)

      
    }

    
    
  };
  

  return (
    <div className='SignUp-Container'>
      <form onSubmit={handleSubmit}>
        <img className='loginLogo' src='./images/loginLogo.png' alt='logo'/>
        <h1 className='SignUp-Title'>Login</h1>
        <input
              type="email"
              className="form-control mb-4 p-4"
              onChange={e=>setEmail(e.target.value)}
              name="email"
              value={email}
              placeholder="john.doe@gmail.com"
              required
        />
        <br />

            <input
              type="password"
              className="form-control mb-4 p-4"
              name="password"
              onChange={e=>setPassword(e.target.value)}
              value={password}
              placeholder="********"
              required
        />
        <br />
        <button className='signup-button'>Login</button>
        {error && <div className="error">{error}</div>}
        <h3 className='linkName'>New here? <a className='Login-Link' href='/register'>Join Now!</a></h3>
      </form>
      
    </div>
  )
}

export default Login